import type { EnumUnion } from '@dresscode-frontend/utility-types';
export const OrderDirection = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
export type OrderDirection = EnumUnion<typeof OrderDirection>;